export default {
  methods: {
    /**
     *
     * @param styles
     */
    addStyle: function (styles) {
      let css = document.createElement('style')
      css.type = 'text/css'
      if (css.styleSheet) css.styleSheet.cssText = styles
      else css.appendChild(document.createTextNode(styles))
      document.getElementsByTagName('head')[0].appendChild(css)
    },
  },
}
